import { Pipe, PipeTransform } from '@angular/core';
import {
  Label,
  Project,
  ProjectStatus,
  ShiftCardBackgroundColor,
  ShiftCategoriesColorCode,
  ShiftCategoriesIdsMap,
  ShiftColorOptions,
} from '@wilson/interfaces';
import { hexWithAlpha } from '@wilson/utils';

export interface ShiftCardColorStyleInput {
  shiftCategoryId: string;
  shiftColorOption: ShiftColorOptions | null | undefined;
  label: Pick<Label, 'colorCode'> | null | undefined;
  project: Pick<Project, 'colorCode' | 'status'> | null | undefined;
  hasProjectReadPermission: boolean;
  presenceBorderColor: string | null | undefined;
}

export interface ShiftCardColorStyle {
  'border-color': string;
  'border-left-color': string;
  'border-width': string;
  background: string;
}

@Pipe({
  name: 'shiftCardColorStyle',
})
export class ShiftCardColorStylePipe implements PipeTransform {
  transform({
    shiftCategoryId,
    shiftColorOption,
    label,
    project,
    hasProjectReadPermission,
    presenceBorderColor,
  }: ShiftCardColorStyleInput): ShiftCardColorStyle {
    const isLabel = shiftColorOption === ShiftColorOptions.Label && !!label;
    const isProject =
      hasProjectReadPermission &&
      shiftColorOption === ShiftColorOptions.Project &&
      !!project;

    let borderColor: string | undefined;
    let backgroundColor: string | undefined;
    if (isLabel) {
      borderColor = label?.colorCode;
      backgroundColor = hexWithAlpha(label?.colorCode);
    } else if (isProject) {
      borderColor = project?.colorCode;
      backgroundColor = hexWithAlpha(project?.colorCode);
    } else {
      borderColor = ShiftCategoriesColorCode[shiftCategoryId];
      backgroundColor = ShiftCardBackgroundColor[shiftCategoryId];
    }

    const isNormalShift =
      shiftColorOption === ShiftColorOptions.ShiftCategory &&
      shiftCategoryId === ShiftCategoriesIdsMap.Normal;
    const isProjectOpen =
      hasProjectReadPermission && project?.status === ProjectStatus.OPEN;

    return {
      'border-color': presenceBorderColor ?? (isProjectOpen ? borderColor : ''),
      'border-left-color':
        presenceBorderColor ??
        (isProjectOpen || !isNormalShift ? borderColor : ''),
      'border-width': presenceBorderColor ? '2px' : '',
      background: backgroundColor ?? '',
    };
  }
}
